var map = {
	"./Book1.json": 1398,
	"./历史类提前批专科.json": 6575,
	"./历史类提前批本科.json": 1000,
	"./历史类普通批专科.json": 1474,
	"./历史类普通批本科.json": 1197,
	"./物理类提前批专科.json": 7344,
	"./物理类提前批本科.json": 535,
	"./物理类普通批专科.json": 553,
	"./物理类普通批本科.json": 9334
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4135;